module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar",
    style: ({
      width: _vm.sidebarDivWidth
    })
  }, [_c('nav', {
    staticClass: "sidebar-nav",
    style: (_vm.getHeight1),
    attrs: {
      "id": "sidebar-nav"
    }
  }, [_c('ul', {
    staticClass: "nav",
    style: ({
      width: _vm.navUlWidth
    })
  }, [_vm._l((_vm.routes), function(item) {
    return [(_vm.nowPage == item.path) ? [(!item.hidden && item.children && item.children.length > 0) ? _c('router-link', {
      class: _vm.navClass1,
      attrs: {
        "tag": "li",
        "to": item.path + '' + item.children[0].path,
        "disabled": ""
      }
    }, [_c('div', {
      staticClass: "nav-link nav-dropdown-toggle",
      on: {
        "click": _vm.handleClick
      }
    }, [_c('Icon', {
      attrs: {
        "type": item.icon,
        "color": "white"
      },
      on: {
        "click": _vm.handleClick2
      }
    }), _vm._v(" "), _c('span', {
      style: (_vm.navStyleObject),
      on: {
        "click": _vm.handleClick2
      }
    }, [_vm._v(_vm._s(item.name) + "\n              ")])], 1), _vm._v(" "), _c('ul', {
      staticClass: "nav-dropdown-items"
    }, _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('li', {
        class: _vm.navClass2,
        on: {
          "click": _vm.addActive
        }
      }, [(!child.hidden && child.children) ? _c('router-link', {
        staticClass: "nav-link",
        attrs: {
          "to": item.path +
            '/' +
            child.path +
            '/' +
            child.children[0].path
        },
        nativeOn: {
          "click": function($event) {
            return _vm.flushCom()
          }
        }
      }, [(
        !item.hidden &&
        item.children &&
        item.children.length > 0
      ) ? _c('router-link', {
        class: _vm.navClass3,
        staticStyle: {
          "background": "rgba(0, 0, 0, 0)"
        },
        attrs: {
          "tag": "li",
          "to": item.path + '' + child.children[0].path,
          "disabled": ""
        }
      }, [_c('div', {
        staticClass: "nav-link nav-dropdown-toggle",
        on: {
          "click": _vm.handleClick
        }
      }, [_c('span', {
        style: (_vm.navStyleObject2)
      }, [_vm._v(_vm._s(child.name) + " ")])]), _vm._v(" "), _c('ul', {
        staticClass: "nav-dropdown-items"
      }, _vm._l((child.children), function(grandson) {
        return (!child.hidden) ? _c('li', {
          class: _vm.navClass3,
          staticStyle: {
            "background": "rgba(0, 0, 0, 0.1)"
          },
          on: {
            "click": _vm.addActive
          }
        }, [(!grandson.hidden && grandson.children) ? _c('router-link', {
          staticClass: "nav-link",
          attrs: {
            "to": item.path +
              '/' +
              child.path +
              '/' +
              grandson.path +
              '/' +
              grandson.children[0].path
          },
          nativeOn: {
            "click": function($event) {
              return _vm.flushCom()
            }
          }
        }, [_c('Icon', {
          attrs: {
            "type": grandson.icon,
            "color": "white"
          }
        }), _vm._v(" "), _c('span', {
          style: (_vm.navStyleObject3)
        }, [_vm._v(_vm._s(grandson.name) + "\n                          ")])], 1) : _c('router-link', {
          staticClass: "nav-link",
          attrs: {
            "to": item.path + '/' + child.path + '/' + grandson.path
          },
          nativeOn: {
            "click": function($event) {
              return _vm.flushCom()
            }
          }
        }, [_c('Icon', {
          attrs: {
            "type": grandson.icon,
            "color": "white"
          }
        }), _vm._v(" "), _c('span', {
          style: (_vm.navStyleObject3)
        }, [_vm._v(_vm._s(grandson.name) + "\n                          ")])], 1)], 1) : _vm._e()
      }), 0)]) : _vm._e()], 1) : _c('router-link', {
        staticClass: "nav-link",
        staticStyle: {
          "padding-left": "30px"
        },
        attrs: {
          "to": item.path + '/' + child.path
        },
        nativeOn: {
          "click": function($event) {
            return _vm.flushCom()
          }
        }
      }, [_c('Icon', {
        attrs: {
          "type": child.icon,
          "color": "white"
        }
      }), _vm._v(" "), _c('span', {
        style: (_vm.navStyleObject2)
      }, [_vm._v(_vm._s(child.name) + " ")])], 1)], 1) : _vm._e()
    }), 0)]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.nowPage != item.path) ? [(!item.hidden && item.children && item.children.length > 0) ? _c('router-link', {
      class: _vm.navClass,
      attrs: {
        "tag": "li",
        "to": item.path + '' + item.children[0].path,
        "disabled": ""
      }
    }, [_c('div', {
      staticClass: "nav-link nav-dropdown-toggle",
      on: {
        "click": _vm.handleClick
      }
    }, [_c('Icon', {
      attrs: {
        "type": item.icon,
        "color": "white"
      },
      on: {
        "click": _vm.handleClick2
      }
    }), _vm._v(" "), _c('span', {
      style: (_vm.navStyleObject),
      on: {
        "click": _vm.handleClick2
      }
    }, [_vm._v(_vm._s(item.name) + "\n              ")])], 1), _vm._v(" "), _c('ul', {
      staticClass: "nav-dropdown-items"
    }, _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('li', {
        class: _vm.navClass2,
        on: {
          "click": _vm.addActive
        }
      }, [(!child.hidden && child.children) ? _c('router-link', {
        staticClass: "nav-link",
        attrs: {
          "to": item.path +
            '/' +
            child.path +
            '/' +
            child.children[0].path
        },
        nativeOn: {
          "click": function($event) {
            return _vm.flushCom()
          }
        }
      }, [(
        !item.hidden &&
        item.children &&
        item.children.length > 0
      ) ? _c('router-link', {
        class: _vm.navClass3,
        staticStyle: {
          "background": "rgba(0, 0, 0, 0)"
        },
        attrs: {
          "tag": "li",
          "to": item.path + '' + child.children[0].path,
          "disabled": ""
        }
      }, [_c('div', {
        staticClass: "nav-link nav-dropdown-toggle",
        on: {
          "click": _vm.handleClick
        }
      }, [_c('span', {
        style: (_vm.navStyleObject2)
      }, [_vm._v(_vm._s(child.name) + " ")])]), _vm._v(" "), _c('ul', {
        staticClass: "nav-dropdown-items"
      }, _vm._l((child.children), function(grandson) {
        return (!child.hidden) ? _c('li', {
          class: _vm.navClass3,
          staticStyle: {
            "background": "rgba(0, 0, 0, 0.1)"
          },
          on: {
            "click": _vm.addActive
          }
        }, [(!grandson.hidden && grandson.children) ? _c('router-link', {
          staticClass: "nav-link",
          attrs: {
            "to": item.path +
              '/' +
              child.path +
              '/' +
              grandson.path +
              '/' +
              grandson.children[0].path
          },
          nativeOn: {
            "click": function($event) {
              return _vm.flushCom()
            }
          }
        }, [_c('Icon', {
          attrs: {
            "type": grandson.icon,
            "color": "white"
          }
        }), _vm._v(" "), _c('span', {
          style: (_vm.navStyleObject3)
        }, [_vm._v(_vm._s(grandson.name) + "\n                          ")])], 1) : _c('router-link', {
          staticClass: "nav-link",
          attrs: {
            "to": item.path + '/' + child.path + '/' + grandson.path
          },
          nativeOn: {
            "click": function($event) {
              return _vm.flushCom()
            }
          }
        }, [_c('Icon', {
          attrs: {
            "type": grandson.icon,
            "color": "white"
          }
        }), _vm._v(" "), _c('span', {
          style: (_vm.navStyleObject3)
        }, [_vm._v(_vm._s(grandson.name) + "\n                          ")])], 1)], 1) : _vm._e()
      }), 0)]) : _vm._e()], 1) : _c('router-link', {
        staticClass: "nav-link",
        staticStyle: {
          "padding-left": "30px"
        },
        attrs: {
          "to": item.path + '/' + child.path
        },
        nativeOn: {
          "click": function($event) {
            return _vm.flushCom()
          }
        }
      }, [_c('Icon', {
        attrs: {
          "type": child.icon,
          "color": "white"
        }
      }), _vm._v(" "), _c('span', {
        style: (_vm.navStyleObject2)
      }, [_vm._v(_vm._s(child.name) + " ")])], 1)], 1) : _vm._e()
    }), 0)]) : _vm._e()] : _vm._e(), _vm._v(" "), (!item.hidden && !item.children) ? _c('li', {
      staticClass: "nav-item"
    }, [_c('router-link', {
      staticClass: "nav-link",
      attrs: {
        "to": item.path,
        "exact": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.flushCom()
        }
      }
    }, [_c('Icon', {
      attrs: {
        "type": item.icon,
        "color": "white"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "adt-span-special",
      style: (_vm.navStyleObject)
    }, [_vm._v(_vm._s(item.name) + "\n            ")])], 1)], 1) : _vm._e()]
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2aeaaea9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarItem.vue
// module id = 1087
// module chunks = 284